import React from 'react';

export default function getDisabledCompatibleTrigger(element) {
  if (element.props.disabled) {
    const displayStyle =
      element.props.style && element.props.style.display
        ? element.props.style.display
        : 'inline-block';
    const child = React.cloneElement(element, {
      style: {
        ...element.props.style,
        pointerEvents: 'none',
      },
    });
    return (
      // eslint-disable-next-line
      <span style={{ display: displayStyle, cursor: 'not-allowed' }}>{child}</span>
    );
  }
  return element;
}
